import { render, staticRenderFns } from "./UpdateInfoConyuge.vue?vue&type=template&id=8f0fb8fe&scoped=true&"
import script from "./UpdateInfoConyuge.vue?vue&type=script&lang=js&"
export * from "./UpdateInfoConyuge.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfoConyuge.vue?vue&type=style&index=0&id=8f0fb8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0fb8fe",
  null
  
)

export default component.exports